const Reload = () => {
    return (
        <div className="reload-overlay">
            <div className="loader"></div>
            <div className="reload-text">
                Carregando
                <span className="dot dot-1">.</span>
                <span className="dot dot-2">.</span>
                <span className="dot dot-3">.</span>
            </div>
            <style>{`
                .reload-text {
                    margin-top: 16px;
                    font-size: 1rem;
                    font-weight: 600;
                    color: #ffffff;
                    letter-spacing: 0.03em;
                }
                .dot {
                    display: inline-block;
                    animation: blink 1.4s infinite both;
                    font-size: 1.2rem;
                    line-height: 1;
                    color: #f4f4f4;
                }
                .dot-1 { animation-delay: 0s; }
                .dot-2 { animation-delay: 0.2s; }
                .dot-3 { animation-delay: 0.4s; }
                @keyframes blink {
                    0%, 80%, 100% { opacity: 0; transform: translateY(0); }
                    40% { opacity: 1; transform: translateY(-4px); }
                }
            `}</style>
        </div>
    );
}
export default Reload;